<template>
    <div>
        <DRow>
            <DCol>
                <DTabs class="mb-3">
                    <DTabItem
                        id="collection-de"
                        :route-url="$route('tools.collection.national')"
                        :active="['tools.collection.national'].includes($route().current())"
                        :label="__('tools.collection.national', { country: $page.props.sidebarTranslationParameters.country })"
                    />
                    <DTabItem
                        v-if="isCollectionPartnerVisma === false"
                        id="collection-foreign"
                        :route-url="$route('tools.collection.foreign')"
                        :active="['tools.collection.foreign'].includes($route().current())"
                        :label="__('tools.collection.foreign')"
                    />
                    <DTabItem
                        v-if="isCollectionPartnerVisma === false"
                        id="history"
                        :route-url="$route('tools.collection.history')"
                        :active="['tools.collection.history'].includes($route().current())"
                        :label="__('tools.collection.history')"
                    />
                    <DTabItem
                        id="batches"
                        :route-url="$route('tools.collection.batches')"
                        :active="['tools.collection.batches'].includes($route().current()) || ['tools.collection.show'].includes($route().current())"
                        :label="__('tools.collection.batches')"
                    />
                </DTabs>
            </DCol>
        </DRow>

        <slot />
    </div>
</template>

<script>
export default {
    name: 'CollectionLayout',
    props: {
        isCollectionPartnerVisma: {
            type: Boolean,
            default: false
        }
    }
}
</script>
